function waitForIframe(containerElement: HTMLElement, callback: Function) {
    const observer = new MutationObserver(() => {
        // debugger;
        const iframe = containerElement.querySelector('iframe');

        if (!iframe) return;

        observer.disconnect();
        iframe.addEventListener('load', handleLoadEvent);

        function handleLoadEvent() {
            iframe.removeEventListener('load', handleLoadEvent);
            callback();
        }
    });

    observer.observe(containerElement, { childList: true, subtree: true });
}

export default waitForIframe;